import type { FC } from 'react';
import { useLDFlag } from 'src/contexts/LaunchDarklyContext/LaunchDarklyContext';
import type { FeatureFlagEntry } from 'src/types/contentful';

const FeatureFlag: FC<FeatureFlagEntry> = ({ fields: { featureFlag } }) => {
  useLDFlag(featureFlag);

  return null;
};

export default FeatureFlag;
